import React from 'react';
import { twMerge } from 'tailwind-merge';
import Loading from './Loading';
const Button = ({
  children,
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  ...props
}) => {
  const baseStyles =
    'flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variantStyles = {
    primary: 'bg-blue-500 text-white hover:bg-blue-600 disabled:bg-gray-500',
    secondary: 'bg-gray-500 text-white hover:bg-gray-600 disabled:bg-gray-500',
    danger: 'bg-red-500 text-white hover:bg-red-600 disabled:bg-gray-500',
  };
  const sizeStyles = {
    sm: 'text-sm px-2 py-1',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-6 py-3',
  };

  const styles = twMerge(
    baseStyles,
    variantStyles[variant],
    sizeStyles[size],
    className,
  );

  return (
    <button className={styles} {...props} disabled={disabled || loading}>
      {loading && (
        <div className="w-4 h-4">
          <Loading />
        </div>
      )}
      {children}
    </button>
  );
};

export default Button;
